// extracted by mini-css-extract-plugin
export default {"root":"ComingSoonItem_root__0sgWL","hint":"ComingSoonItem_hint__SM+Jd"};